export const SHIFTS = "SHIFTS";
export const WORKERS = "WORKERS";